import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_ADMIN_ROLES, res.data)
  })
)

export const getRole = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_ADMIN_ROLE, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.saveRole(obj).then(res => {
    commit(types.SET_ADMIN_ROLE, res.data.data)
    return res
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}

export const deleteRole = async ({ commit }, obj) => {
  await services.deleteRole(obj).then(res => {
    return res
  })
}
